/* eslint-disable @typescript-eslint/no-explicit-any */
interface NRAttributes {
  logLevel: 'error' | 'info' | 'warn';
  message: string;
  logCode: ILogCode;
  logName: ILogName;
  locale: string;
  deviceType: string;
  env: string;
  deploymentName: string;
  [x: string]: any;
}

type ILogName =
  | 'CA_ERROR' // CA generic error
  | 'CA_FIRE_IMPRESSION_ERROR' // Optimizely Error
  | 'CA_PAGE_PROPERTIES_ERROR' // Error Occured in computing page properties
  | 'CA_EVENTS_ERROR' // Error in SF Events
  | 'CA_OUTSIDE_BUSINESS_HR' // Business Hr Check
  | 'CA_AGENT_UNAVAILABLE' // Agent Unavailablity
  | 'CA_CHAT_ESTABLISHED' // Chat Established;
  | 'CA_CHAT_REQUEST_SUCCESS'
  | 'CA_AGENT_CONNECTION_LOST'
  | 'CA_HELP_BUTTON_CLICKED'
  | 'CA_CHAT_ENDED_BY_USER'
  | 'CA_CHAT_ENDED_BY_AGENT'
  | 'CA_DISABLED_CLICK'
  | 'CA_CHANNEL_PROVIDER_ENTRY_NOT_FOUND'
  | 'CA_BUSINESS_HR_END'
  | 'CA_USER_LASTNAME_EMPTY'
  | 'CA_USER_FIRSTNAME_EMPTY'
  | 'CA_USER_FIRSTNAME_EMPTY_UPDATED_WITH_EMAILID'
  | 'CA_USER_LASTNAME_EMPTY_UPDATED_WITH_EMAILID'
  | 'CA_USER_LASTNAME_EMPTY_UPDATED_WITH_FIRSTNAME'
  | 'CA_USER_EMAIL_EMPTY'
  | 'CA_HIDE_ON_BUSINESS_HR_END';

type ILogCode =
  // For Errors/warn  use logCode CA0XX
  | 'CA001'
  | 'CA002'
  | 'CA003'
  | 'CA004'
  // For Info use logCode CA9XX
  | 'CA999'
  | 'CA998'
  | 'CA997'
  | 'CA996'
  | 'CA995'
  | 'CA994'
  | 'CA993'
  | 'CA992'
  | 'CA991'
  | 'CA990'
  | 'CA989'
  | 'CA988'
  | 'CA987'
  | 'CA986'
  | 'CA985'
  | 'CA984'
  | 'CA983'
  | 'CA981'
  | 'CA980'
  | 'CA970'
  | 'CA971'
  | 'CA972'
  | 'CA973'
  | 'CA982';

// eslint-disable-next-line no-unused-vars
const logCodeMapping: { [x in ILogName]: ILogCode } = {
  CA_ERROR: 'CA001',
  CA_FIRE_IMPRESSION_ERROR: 'CA002',
  CA_PAGE_PROPERTIES_ERROR: 'CA003',
  CA_EVENTS_ERROR: 'CA004',
  CA_OUTSIDE_BUSINESS_HR: 'CA999',
  CA_AGENT_UNAVAILABLE: 'CA998',
  CA_CHAT_ESTABLISHED: 'CA997',
  CA_CHAT_REQUEST_SUCCESS: 'CA996',
  CA_AGENT_CONNECTION_LOST: 'CA995',
  CA_HELP_BUTTON_CLICKED: 'CA994',
  CA_CHAT_ENDED_BY_USER: 'CA993',
  CA_CHAT_ENDED_BY_AGENT: 'CA992',
  CA_DISABLED_CLICK: 'CA986',
  CA_CHANNEL_PROVIDER_ENTRY_NOT_FOUND: 'CA984',
  CA_BUSINESS_HR_END: 'CA983',
  CA_HIDE_ON_BUSINESS_HR_END: 'CA982',
  CA_USER_LASTNAME_EMPTY: 'CA981',
  CA_USER_FIRSTNAME_EMPTY: 'CA980',
  CA_USER_FIRSTNAME_EMPTY_UPDATED_WITH_EMAILID: 'CA970',
  CA_USER_LASTNAME_EMPTY_UPDATED_WITH_EMAILID: 'CA971',
  CA_USER_LASTNAME_EMPTY_UPDATED_WITH_FIRSTNAME: 'CA972',
  CA_USER_EMAIL_EMPTY: 'CA973',
};

export { ILogName, ILogCode, NRAttributes, logCodeMapping };
